import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SnackbarProvider } from "notistack";

/** 食品メーカー向けサービス App コンポーネント */
const HaccpApp = ({ children }) => {
    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            dateFormats={{ monthAndYear: 'yyyy年 MM月' }}
            localeText={{ previousMonth: '前月', nextMonth: '次月' }}>
            <SnackbarProvider autoHideDuration={5000}>
                {children}
            </SnackbarProvider>
        </LocalizationProvider>
    );    
};

export default HaccpApp;
